import { IconComponentProps } from '../IconTypes';

const Collapse = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.71001 12.29L11.3 9.69997C11.69 9.30997 12.32 9.30997 12.71 9.69997L15.3 12.29C15.93 12.92 15.48 14 14.59 14H9.41001C8.52001 14 8.08001 12.92 8.71001 12.29Z"
      fill="currentColor"
    />
  </svg>
);

export default Collapse;
